import styled from 'styled-components';
import { BLUE_RIBBON_300, DARK_VIOLET } from '@styles/colors';
import { GIVONIC } from '@styles/fonts';

export const ActionButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  width: 72px;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border: 1px solid ${BLUE_RIBBON_300};
  border-radius: 100%;
  background-color: white;
  margin-bottom: 4px;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.span`
  font-family: ${GIVONIC.semiBold};
  font-size: 14px;
  color: ${DARK_VIOLET};
  text-align: center;
`;
